// Single source of truth mapping a route path to the license module that
// gates it. Used by both the Sidebar (to hide nav links) and PrivateRoute
// (to block direct URL access) so the two can never drift out of sync.
const ROUTE_MODULES = {
  // Admin
  '/admin/classes': 'classes',
  '/admin/transport': 'transport',
  '/admin/fees': 'fees',
  '/admin/salary': 'salary',
  '/admin/attendance': 'attendance',
  '/admin/leaves': 'leaves',
  '/admin/exams': 'exams',
  '/admin/communications': 'communications',
  '/admin/expenses': 'expenses',
  '/admin/progress-reports': 'progressReports',
  '/admin/non-teaching-staff': 'nonTeachingStaff',

  // Teacher
  '/teacher/selfie-attendance': 'attendance',
  '/teacher/attendance': 'attendance',
  '/teacher/class': 'classes',
  '/teacher/leaves': 'leaves',
  '/teacher/subjects': 'classes',
  '/teacher/daily-modules': 'dailyModules',
  '/teacher/exams': 'exams',
  '/teacher/timetable': 'timetable',
  '/teacher/materials': 'materials',
  '/teacher/events': 'events',
  '/teacher/progress-reports': 'progressReports',

  // Parent
  '/parent/attendance': 'attendance',
  '/parent/fees': 'fees',
  '/parent/transport': 'transport',
  '/parent/daily-modules': 'dailyModules',
  '/parent/exams': 'exams',
  '/parent/timetable': 'timetable',
  '/parent/materials': 'materials',
  '/parent/events': 'events',
  '/parent/progress-reports': 'progressReports',

  // Principal
  '/principal/attendance': 'attendance',
  '/principal/leaves': 'leaves',
  '/principal/daily-modules': 'dailyModules',
  '/principal/subjects': 'classes',
  '/principal/fees': 'fees',
  '/principal/exams': 'exams',
  '/principal/timetable': 'timetable',
  '/principal/materials': 'materials',
  '/principal/events': 'events',
  '/principal/expenses': 'expenses',
  '/principal/progress-reports': 'progressReports',
  '/principal/non-teaching-staff': 'nonTeachingStaff',
};

export default ROUTE_MODULES;
